import styles from "./MetricCard.module.css";
import type {TournamentMetrics} from '@iziping/common';
import {MetricCard} from "./MetricCard";

interface MetricsSectionProps {
    metrics?: TournamentMetrics[];
    isLoading: boolean;
    isError: boolean;
}

export const MetricsSection = ({
                                   metrics,
                                   isLoading,
                                   isError,
                               }: MetricsSectionProps) => {
    if (isLoading) {
        return (
            <div className={styles.metricsGrid}>
                {metrics?.map((metric) => (
                    <MetricCard metric={metric} />
                ))}
            </div>
        );
    }

    if (isError) {
        return <div>Erreur lors du chargement des métriques</div>;
    }

    if (!metrics || metrics.length === 0) {
        return <div>Aucune métrique disponible</div>;
    }

    return (
        <div className={styles.metricsGrid}>
            {metrics.map((metric) => (
                <MetricCard metric={metric} />
            ))}
        </div>
    );
};